import { PageLocatorMap } from '../types/PageLocatorMap';

export const activationPinVerifyPage = {
  alert: {
    error: 'activation-pin-verify-page.alert.error',
    success: 'activation-pin-verify-page.alert.success',
  },
  footer: {
    root: 'activation-pin-verify-page.footer.root',
  },
  form: {
    h1: 'activation-pin-verify-page.form.heading1',
    h3: 'activation-pin-verify-page.form.heading3',
    pinInput1: 'activation-pin-verify-page.form.pin-input-1',
    pinInput2: 'activation-pin-verify-page.form.pin-input-2',
    pinInput3: 'activation-pin-verify-page.form.pin-input-3',
    pinInput4: 'activation-pin-verify-page.form.pin-input-4',
    pinInput5: 'activation-pin-verify-page.form.pin-input-5',
    pinInput6: 'activation-pin-verify-page.form.pin-input-6',
    pinInputError: 'activation-pin-verify-page.form.pin-error',
    resendPinLink: 'activation-pin-verify-page.form.resend-pin-link',
    root: 'activation-pin-verify-page.form.root',
  },
} as const satisfies PageLocatorMap;
